// extracted by mini-css-extract-plugin
export default {"formContainer":"formContainer___jLK2x","dark":"dark","slogan":"slogan___CztmU","submitBtn":"submitBtn___TZ9xV","selectBtn":"selectBtn___LncDN","mobileBtn":"mobileBtn____Py8G"};